<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-settings
            :id="id"
            ref="memberSettings"
            :club-id="clubId"
        />
        <hr class="kgr-separator--light" />
        <kgr-member-bank-accounts
            :id="id"
            :club-id="clubId"
            @save="onBankAccountSave"
        />
        <hr class="kgr-separator--light" />
        <kgr-member-mandate-references
            :member-id="id"
            :club-id="clubId"
            @save="onMandateReferenceSave"
        />
        <hr class="kgr-separator--light" />
        <kgr-member-sepa-debits
            :id="id"
            ref="sepaDebits"
            :club-id="clubId"
            @save="onSepaDebitSave"
        />
    </kgr-form-scaffold>
</template>

<script>
import FormScaffold from '../../../components/common/form/FormScaffold.vue';
import MemberBankAccounts from './MemberBankAccounts.vue'
import MemberMandateReferences from './MemberMandateReferences.vue'
import MemberSepaDebits from './MemberSepaDebits.vue'
import MemberSettings from './MemberSettings.vue'

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-member-mandate-references': MemberMandateReferences,
        'kgr-member-bank-accounts': MemberBankAccounts,
        'kgr-member-sepa-debits': MemberSepaDebits,
        'kgr-member-settings': MemberSettings,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
        }
    },
    computed: {
    },
    created() {
    },
    methods: {
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/members`;
        },
        onMandateReferenceSave() {
            if (this.$refs.sepaDebits && this.$refs.sepaDebits.loadMemberMandateReferences) {
                this.$refs.sepaDebits.loadMemberMandateReferences();
            }
        },
        onBankAccountSave() {
            if (this.$refs.sepaDebits && this.$refs.sepaDebits.loadMemberBankAccounts) {
                this.$refs.sepaDebits.loadMemberBankAccounts();
            }
        },
        onSepaDebitSave() {
            if (this.$refs.memberSettings && this.$refs.memberSettings.load) {
                this.$refs.memberSettings.load();
            }
        }
    },
}
</script>
